export const TheLayoutFallback = () => {
  const supportEmail = "support@nuclearn.ai";
  const subject = "Support Request";
  const body = "Hello, I need help with...";

  const buttonStyle: React.CSSProperties = {
    color: "white",
    width: "40%",
    backgroundColor: "#1976d2",
    border: "none",
    borderRadius: 4,
    padding: "8px 16px",
    fontSize: "0.875rem",
    fontWeight: 500,
    textTransform: "uppercase",
    textDecoration: "none",
    textAlign: "center",
    cursor: "pointer",
    letterSpacing: "0.02857em",
    lineHeight: 1.75,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div
      data-testid="err-page"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        flexDirection: "column",
        backgroundImage: "url(/images/stock/npp.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <div
        data-testid="err-content"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          backgroundColor: "rgba(162, 99, 99, 0.1)",
          padding: "3%",
          borderRadius: 10,
          background:
            "linear-gradient(#fff, #fff) padding-box, linear-gradient(90deg, #5bb3d6, #47c972) border-box",
          border: "2px solid transparent",
          boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <h1 data-testid="err-title" style={{ textAlign: "center" }}>
          Something went wrong!
        </h1>
        <br />
        <h4 data-testid="err-subtitle" style={{ textAlign: "center" }}>
          We're unable to load the page you requested.
        </h4>
        <br />
        <h5 data-testid="err-text-support" style={{ textAlign: "center" }}>
          Our team has been notified, and we're working on fixing the issue.
          <br />
          Please try again later or{" "}
          <a
            data-testid="err-link-contact-inline"
            href={`mailto:${supportEmail}?subject=${encodeURIComponent(
              subject,
            )}&body=${encodeURIComponent(body)}`}
          >
            Contact Support
          </a>{" "}
          if the problem continues.
        </h5>
        <br />
        <br />
        <div className="d-flex align-items-center justify-content-center">
          <img
            data-testid="err-img-logo"
            src="/images/NuclearN1-B.gif"
            alt="NuclearN Logo"
            style={{ width: "200px" }}
          />
        </div>
        <br />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <a data-testid="err-link-back-to-home" style={buttonStyle} href="/">
            Back to Home
          </a>
          <a
            data-testid="err-link-contact-support"
            style={buttonStyle}
            href={`mailto:${supportEmail}?subject=${encodeURIComponent(
              subject,
            )}&body=${encodeURIComponent(body)}`}
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};
